import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const DetalleNivelBodega = props => {
    return (
      <option dato1={props.elemento.codigoBodega} dato2={props.elemento.descrBodega} value={props.elemento._id}>{props.elemento.codigoBodega} ={">"} {props.elemento.descrBodega}</option>
    )
  };

  const ListaBodega = ({handleLista, list}) => {
      const NivelDetalleBodega = list.map((elemento, _id) => <DetalleNivelBodega elemento={elemento} key={elemento._id} />);
      return(
          <div>
              <select className="ui simple selection dropdown fluid" name="bodega" id="miLista3" onChange={handleLista}>
                  <option value="">Seleccionar...</option>
                  {NivelDetalleBodega}
              </select>
          </div>
      )
  };

const DetalleNivelFabri = props => {
    return (
      <option dato1={props.elemento.codigoFabriEqu} dato2={props.elemento.descrFabriEqu} value={props.elemento._id}>{props.elemento.codigoFabriEqu} ={">"} {props.elemento.descrFabriEqu}</option>
    )
  };

  const ListaFabri = ({handleLista, list}) => {
      const NivelDetalleFabri = list.map((elemento, _id) => <DetalleNivelFabri elemento={elemento} key={elemento._id} />);
      return(
          <div>
              <select className="ui simple selection dropdown fluid" name="fabriequ" id="miLista2" onChange={handleLista}>
                  <option value="">Seleccionar...</option>
                  {NivelDetalleFabri}
              </select>
          </div>
      )
  };

const DetalleNivelMarca = props => {
    return (
      <option dato1={props.elemento.codigoMarcaEqu} dato2={props.elemento.descrMarcaEqu} value={props.elemento._id}>{props.elemento.codigoMarcaEqu} ={">"} {props.elemento.descrMarcaEqu}</option>
    )
  };

  const ListaMarca = ({handleLista, list}) => {
      const NivelDetalleMarca = list.map((elemento, _id) => <DetalleNivelMarca elemento={elemento} key={elemento._id} />);
      return(
          <div>
              <select className="ui simple selection dropdown fluid" name="marcaequ" id="miLista1" onChange={handleLista}>
                  <option value="">Seleccionar...</option>
                  {NivelDetalleMarca}
              </select>
          </div>
      )
  };

const DetalleNivelClase = props => {
  return (
    <option dato1={props.elemento.codigoClaseEqu} dato2={props.elemento.descrClaseEqu} value={props.elemento._id}>{props.elemento.codigoClaseEqu} ={">"} {props.elemento.descrClaseEqu}</option>
  )
};

const ListaClase = ({handleLista, list}) => {
    const NivelDetalleClase = list.map((elemento, _id) => <DetalleNivelClase elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select className="ui simple selection dropdown fluid" name="claseequ" id="miLista" onChange={handleLista}>
                <option value="">Seleccionar...</option>
                {NivelDetalleClase}
            </select>
        </div>
    )
};

const AddEqu2 = ({styles, list, list1, list2, list3, handleLista, handleLista1, handleLista2, handleLista3, handleSubmit, handleChange, args, errors}) => {
// console.log(args)
  return(
        <div>
            <button className="ui right labeled icon button" style={styles.titBuscar}>
                <i className="large plus yellow icon"></i>
                Equipo nuevo
            </button>
            <div style={styles.box}>
                <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
                    <div className="ui one column stackable grid">
                        <div className="row container">
                            <div className="column" width="100%">
                                <Form.Field>
                                    <label style={styles.label}>Serial</label>
                                    <Form.Input autoComplete="off" name="numeroSerie" id="numeroSerie" onChange={handleChange} placeholder='Serial' icon={!errors.length?null: _find(errors, {path:'numeroSerie'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Mac</label>
                                    <Form.Input autoComplete="off" name="mac" id="mac" onChange={handleChange} placeholder='Mac' icon={!errors.length?null: _find(errors, {path:'mac'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Clase</label>
                                    <ListaClase list={list} styles={styles} handleLista={handleLista} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Marca</label>
                                    <ListaMarca list={list1} styles={styles} handleLista={handleLista1} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Fabricante</label>
                                    <ListaFabri list={list2} styles={styles} handleLista={handleLista2} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Bodega</label>
                                    <ListaBodega list={list3} styles={styles} handleLista={handleLista3} />
                                </Form.Field>

                                <Button style={styles.confirmar} type='submit' fluid>
                                    AGREGAR
                                </Button>

                                {
                                    errors.length?<Message negative header="Los siguientes errores:"
                                    list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                                }
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default AddEqu2
